import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import './index.css';
import App from './App';
import store from './store';
import { unregister } from './registerServiceWorker';
import { BRAND } from './constants/Constants';

export const muiTheme = getMuiTheme({
  ...BRAND.theme,
  zIndex: {
    appBar: 700,
    layer: 1000,
    drawerOverlay: 800,
    drawer: 900,
    ...BRAND.theme.zIndex
  },
  palette: {
    primary1Color: '#049BE5',
    primary2Color: '#029AE4',
    accent1Color: '#FF9700',
    pickerHeaderColor: '#049BE5',
    textColor: '#212121',
    ...BRAND.theme.palette
  }
});

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js